import { Email, Stripe } from '@insify/design-system/line-icons';
import { IconList, RichContentIntro } from '@insify/funnel-components';
import { useTranslation } from 'react-i18next';

import { useContent } from '../../../../hooks/useContent';

import * as styles from './Consents.module.css';

export const Consents = () => {
  const { t } = useTranslation(['funnel']);
  const { checkoutImportantInformation } = useContent() || {};

  const consents = [
    {
      Icon: Stripe,
      Body: () => t('funnel:checkout_important_information_payment'),
    },
    {
      Icon: Email,
      Body: () => t('funnel:checkout_important_information_documents'),
    },
  ];

  return (
    <>
      <RichContentIntro content={checkoutImportantInformation} />
      <IconList kind='big' className={styles.consents} list={consents} />
    </>
  );
};
